export default __webpack_public_path__ + "static/media/file-tender-public-revoked.a4b5b472.svg";